import Alpine from 'alpinejs';

window.Alpine = Alpine;
Alpine.start();

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';